import React, {
  ComponentPropsWithRef,
  forwardRef,
  HTMLAttributes,
} from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { ReactDefaultProps } from "../../types/react";

import styles from "./TileImageTeaser.scss";

type TileImageTeaserTileVisualBasePropsProps = {
  src: string;
  srcM?: string;
  srcL?: string;
  srcXL?: string;
  alt: string;
  customClass?: string;
  wrapperCustomClass?: string;
  wrapperProps?: HTMLAttributes<HTMLDivElement>;
};

export type TileImageTeaserTileVisualProps = TileImageTeaserTileVisualBasePropsProps &
  Omit<HTMLAttributes<HTMLImageElement>, "src" | "alt">;

const defaultProps = {
  srcM: undefined,
  srcL: undefined,
  srcXL: undefined,
  customClass: undefined,
  wrapperCustomClass: undefined,
  wrapperProps: undefined,
} as const;

const validatedDefaultProps: ReactDefaultProps<
  TileImageTeaserTileVisualBasePropsProps,
  typeof defaultProps
> = defaultProps;

const TileImageTeaserTileVisualWithRef = (
  props: TileImageTeaserTileVisualProps,
  forwardedRef: ComponentPropsWithRef<"div">["ref"]
): JSX.Element => {
  const {
    src,
    srcM,
    srcL,
    srcXL,
    alt,
    customClass,
    wrapperCustomClass,
    wrapperProps,
    ...restProps
  } = props;
  return (
    <div
      className={cx(styles["visual-wrapper"], wrapperCustomClass)}
      ref={forwardedRef}
      {...wrapperProps}
    >
      <picture>
        {srcXL && <source srcSet={srcXL} media="(min-width: 1344px)" />}
        {srcL && <source srcSet={srcL} media="(min-width: 1024px)" />}
        {srcM && <source srcSet={srcM} media="(min-width: 640px)" />}
        <img
          className={cx(styles["visual-image"], customClass)}
          src={src}
          alt={alt}
          {...restProps}
        />
      </picture>
    </div>
  );
};

export const TileImageTeaserTileVisual = forwardRef(
  TileImageTeaserTileVisualWithRef
);

TileImageTeaserTileVisual.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  srcM: PropTypes.string,
  srcL: PropTypes.string,
  srcXL: PropTypes.string,
  customClass: PropTypes.string,
  wrapperCustomClass: PropTypes.string,
  wrapperProps: PropTypes.shape({}),
};

TileImageTeaserTileVisual.defaultProps = validatedDefaultProps;

TileImageTeaserTileVisual.displayName = "TileImageTeaser.Tile.Visual";

export default TileImageTeaserTileVisual;
